import { Component } from 'react'

export default class extends Component {
  static displayName = 'DropdownPopover'
  render() {
    return this.props.children || null
  }
}
